import CopyTextBanner from './CopyTextBanner.component';

export default CopyTextBanner;
